// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3c641542","455":"b64d7f18","977":"e2e4f2e3"}[chunkId] + ".chunk.js";
};